import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  // Inicializar a partir do localStorage ou usar o tema claro como padrão
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  // Aplicar o tema ao corpo do documento quando mudar
  useEffect(() => {
    console.log("ThemeContext: Aplicando tema", isDark ? "escuro" : "claro");
    
    if (isDark) {
      document.body.classList.add('dark-theme');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  // Função para alternar entre temas
  const toggleTheme = () => {
    console.log("ThemeContext: toggleTheme chamado, alterando de", isDark ? "escuro" : "claro", "para", !isDark ? "escuro" : "claro");
    setIsDark(prevState => !prevState);
  };

  const value = {
    isDark,
    toggleTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext; 